<template>
  <div id="container-link-contracts">
      <div class="header-module">
		  <div class="header-col-one">
            <button id="btn-new-contract" class="btn btn-outline-success" @click="openFormModal()" :disabled="!permission">
                <i class="fas fa-plus-circle"></i>
                Novo Contrato de Link
            </button>
            <div class="search-icon">
                <input type="text" class="search-contract" v-model="search" placeholder="Pesquisar contrato">
                <i class="fas fa-search"/>
            </div>
		  </div>
			<div class="header-col-two">
				<div class="quantity-viewed">
					<span>Visualizar </span>
					<select class="" v-model="pageSize">
						<option :value="5">5</option>
						<option :value="10">10</option>
						<option :value="20">20</option>
						<option :value="25">25</option>
						<option :value="100000000000000000"> Todos</option>
					</select>
				</div>

                <div class="buttons-export">
                    <button type="button" @click="exportToCSV" class="btn btn-success btn-sm"><i class="fas fa-file-csv"/> Exportar CSV</button>
                </div>
			</div>
      </div>
      <div class="content">
          <table id='contract-table' class="contract-table" >
              <tr class="header-table">
                    <th class="text-center" rowspan="2" @click="orderBy('contract_code')">
                        <i class="fas fa-fingerprint" />
                        Codigo
						<i :class="iconSort('contract_code')"/>
                    </th>

                    <th class="text-center" colspan="2">
                        <i class="fas fa-user" />
                        Cliente
                    </th>

                    <th class="text-center" colspan="2">
                        <i class="fas fa-users" />
                        Fornecedor
                    </th>

                    <th class="text-center" rowspan="2" @click="orderBy('address')">
                        <i class="fas fa-map-marker-alt" />
                        Endereço
                        <i :class="iconSort('address')"/>
                    </th>

                    <th v-if="permission" class="text-center" rowspan="2" @click="orderBy('monthly_payment')">
                        <i class="fas fa-dollar-sign" />
                        Mensalidade
                        <i :class="iconSort('monthly_payment')"/>
                    </th>

                    <th v-if="permission" class="text-center" rowspan="2" @click="orderBy('renovation')">
                        <i class="fas fa-sync" />
                        Renovação Autimatica
                        <i :class="iconSort('renovation')"/>
                    </th>

                    <th class="text-center" rowspan="2" @click="orderBy('cnpj_advance')">
                        <i class="fas fa-city" />
                        CNPJ
                        <i :class="iconSort('cnpj_advance')"/>
                    </th>

                    <th class="text-center" rowspan="2" @click="orderBy('contract_end')">
                        <i class="fas fa-calendar-alt" />
                        Final do Contrato
                        <i :class="iconSort('contract_end')"/>
                    </th>

                    <th class="text-center" rowspan="2" @click="orderBy('contracted_speed')">
                        <i class="fas fa-tachometer-alt" />
                        Velocidade
                        <i :class="iconSort('contracted_speed')"/>
                    </th>

                    <th class="text-center" rowspan="2" @click="orderBy('config_ip')">
                        <i class="fas fa-network-wired" />
                        Config. de IP
                        <i :class="iconSort('config_ip')"/>
                    </th>

                    <th class="text-center" rowspan="2" @click="orderBy('services')">
                        <i class="fas fa-wrench" />
                        Serviços
                        <i :class="iconSort('services')"/>
                    </th>

                    <th class="text-center" rowspan="2" @click="orderBy('technology')">
                        <i class="fas fa-project-diagram" />
                        Tecnologia
                        <i :class="iconSort('technology')"/>
                    </th>

                    <th class="text-center" rowspan="2" @click="orderBy('indice')">
                        <i class="fas fa-bullseye" />
                        Índice
                        <i :class="iconSort('indice')"/>
                    </th>

                    <th class="text-center" rowspan="2" @click="orderBy('description')">
                        <i class="fas fa-align-left" />
                        Descrição
                        <i :class="iconSort('description')"/>
                    </th>

                    <th class="text-center" rowspan="2">
                        <i class="fas fa-edit" />
                        Editar
                    </th>
              </tr>
                <tr>
                    <th @click="orderBy('client_name')">
                        Nome (Unidade)
                        <i :class="iconSort('client_name')"/>
                    </th>
                    <th @click="orderBy('client_contacts')">
                        Contatos
                        <i :class="iconSort('client_contacts')"/>
                    </th>
                    <th @click="orderBy('provider_name')">
                        Nome
                        <i :class="iconSort('provider_name')"/>
                    </th>
                    <th @click="orderBy('provider_contacts')">
                        Contatos
                        <i :class="iconSort('provider_contacts')"/>
                    </th>
                    <th colspan="6"></th>
                </tr>

                <!---------- corpo da tabela ---------->
                <tr v-for="(item, index) in searchContracts" :key="index" :class="expiringContract(item.contract_end) ? 'expiring-contract' : ''">
                    <td>{{ item.contract_code }}</td>
                    <td>{{ `${item.client_name} (${item.client_unit})` }}</td>
                    <td :class="item.client_contacts.length > 1 ? 'tooltip-container cursor-pointer' : 'tooltip-container'">
                        <span class="tooltip-text" v-if="item.client_contacts.length > 1">
                            <strong>Telefones:</strong>
                            <hr style="margin: 4px 0px">
                            <span v-for="contact in item.client_contacts" :key="contact.phone">
                                {{ `${contact.name}:${contact.phone}` }}
                                <br>
                            </span>
                        </span>
                        {{ `${item.client_contacts[0].name}: ${item.client_contacts[0].phone}` }}
                        <i class="fas fa-eye" style="font-size: 10px; margin-left: 5px;" v-if="item.client_contacts.length > 1"/>
                    </td>
                    <td>{{ item.provider_name }}</td>
                    <td :class="item.provider_contacts.length > 1 ? 'tooltip-container cursor-pointer' : 'tooltip-container'">
                        <span class="tooltip-text" v-if="item.provider_contacts.length > 1">
                            <strong>Telefones:</strong>
                            <hr style="margin: 4px 0px">
                            <span v-for="contact in item.provider_contacts" :key="contact.phone">
                                {{ `${contact.name}:${contact.phone}` }}
                                <br>
                            </span>
                        </span>
                        {{ `${item.provider_contacts[0].name}: ${item.provider_contacts[0].phone}` }}
                        <i class="fas fa-eye" style="font-size: 10px; margin-left: 5px;" v-if="item.provider_contacts.length > 1"/>
                    </td>
                    <td style="white-space: nowrap">{{ formatLongText(item.address) }}</td>
                    <td v-if="permission">{{ formatCurrency(item.monthly_payment) }}</td>
                    <td v-if="permission">{{ item.renovation ? "Sim" : "Não" }}</td>
                    <td>{{ item.cnpj_advance }}</td>
                    <td>{{ formatDate(item.contract_end) }}</td>
                    <td>{{ item.contracted_speed }}M</td>
                    <td>{{ item.config_ip }}</td>
                    <td>{{ item.services }}</td>
                    <td>{{ item.technology }}</td>
                    <td>{{ item.indice }}</td>
                    <td>{{ formatLongText(item.description) }}</td>
                    <td>
                        <button @click="openFormModal(item)" :class="expiringContract(item.contract_end) ? 'btn btn-outline-light btn-sm' : 'btn btn-outline-primary btn-sm'" >
                            <i class="fas fa-pencil-alt"/>
                            Editar
                        </button>
                    </td>
                </tr>
            </table>
      </div>

        <footer class="footer-table">
            <div class="registers">Total de {{ totalRegisters }} Contratos de Link</div>
            <div class="pagination">
                <button class="btn btn-outline-primary previus" @click="prevPage">
                    <i class="fas fa-angle-left"/>
                </button>
                <!-- <button class="btn btn-outline-primary" disabled>...</button> -->
                <button :class="currentPage == page ? 'btn btn-primary' : 'btn btn-outline-primary'" @click="currentPage = page" v-for="(page, index) in showPages" :key="index">{{ page }}</button>
                <!-- <button class="btn btn-outline-primary" disabled>...</button> -->
                <button class="btn btn-outline-primary next" @click="nextPage">
                    <i class="fas fa-angle-right" />
                </button>
            </div>
        </footer>

      <ContractFormModal v-if="showModal" @close="showModal = !showModal"  @updateTable="getLinkContracts" :contract="edit" :permission="permission"/>
  </div>
</template>

<script>
import ContractFormModal from './ContractFormModal';
import moment from 'moment';
import axios from 'axios';
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'

export default {
    components: {
        ContractFormModal,
    },
    data() {
        return {
            showModal: false,
            contracts: [],
            edit: {},
            permission: false,
            search: '',
            currentSort: '',
            currentSortDir: 'asc',
            pageSize: 10,
            currentPage: 1,
            totalPages: 0,
            totalRegisters: 0
        }
    },
    computed: {
        searchContracts() {
            const filter = this.contracts.filter(row => {
                const clientCode = row.contract_code;
                const clientName = row.client_name.toLowerCase();
                const providerName = row.provider_name.toLowerCase();
                const address = row.address.toLowerCase();
                const date = row.contract_start.toLowerCase();
                const whatSearch = this.search.toLowerCase();
                return (
                    clientCode.includes(whatSearch) ||
                    clientName.includes(whatSearch) ||
                    providerName.includes(whatSearch) ||
                    address.includes(whatSearch) ||
                    date.includes(whatSearch)
                );
            });

            this.totalPages = Math.ceil(filter.length / this.pageSize);
            this.totalRegisters = filter.length;
            return this.paginate(filter);
        },
        showPages() {
            const pages = [];
            for(let i = 1; i < this.totalPages + 1; i++) {
                if((i == this.currentPage) || ((this.currentPage+4 >= i) && (this.currentPage-4 <= i))) {
                    pages.push(i);
                }
            }
            return pages;
        },

    },
    methods: {
        iconSort(sort) {
            if(this.currentSort == sort) {
                return this.currentSortDir == 'asc' ? 'fas fa-sort-amount-up' : 'fas fa-sort-amount-down';
            } else {
                return '';
            }
        },
        formatLongText(text) {
            return text && text.length > 30 ? text.substring(30, 0) + '...' : text;
        },
        expiringContract(date) {
            const today = moment().add(3, 'months').format("YYYY-MM-DD");
            return today >= date ? true : false;
        },
        getLinkContracts() {
            axios.get(`${window.location.href}/list`).then(({ data }) => {
                this.contracts = data;
                this.totalPages = Math.ceil(data.length / this.pageSize);
                this.totalRegisters = data.length;
            });
        },
        accessLevel() {
            axios.get(`${window.location.href}/accessLevel`).then(({ data }) => {
                this.permission = data;
            });
        },
        openFormModal(data = null) {
            this.edit = data;
            this.showModal = !this.showModal;
        },
        formatDate(date) {
            return moment(date).format("DD/MM/YYYY");
        },
        formatCurrency(currency) {
            return parseFloat(currency).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            });
        },
        orderBy(sort) {
            if(sort == this.currentSort) {
                this.currentSortDir = this.currentSortDir == 'asc' ? 'desc' : 'asc';
            }
            this.currentSort = sort;
        },
        nextPage() {
            if((this.currentPage * this.pageSize) < this.contracts.length) this.currentPage++;
        },
        prevPage() {
            if(this.currentPage > 1) this.currentPage--;
        },
        paginate(data) {
            return data.sort((a, b) => {
                let modifier = 1;
                if(this.currentSortDir == 'desc') modifier = -1;
                if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                return 0;
            }).filter((row, index) => {
                const start = (this.currentPage - 1) * this.pageSize;
                const end = this.currentPage * this.pageSize;
				return (index >= start && index < end);
            });
        },
        formatRenovation(reno) {
            return reno ? "Sim" : "Não";
        },
        formatDescription(desc) {
            return typeof desc === 'string' ? desc.replace(/(\r\n|\n|\r)/gm, " ") : "";
        },
        formatNullField(field) {
            return field ? field : "";
        },
        exportToCSV() {
            let csv = ['Codigo;Nome do Cliente (Unidade);Contatos do Cliente;Nome do Fornecedor;Contatos do Fornecedor;Endereço;Mensalidade;Renovação Automatica;CNPJ;Final do Contrato;Velocidade;Config. de IP;Serviços;Tecnologia;Índice;Descrição'];
            this.contracts.forEach(obj => {
                const row = `${this.formatNullField(obj.contract_code)};`
                + `${this.formatNullField(obj.client_name)} (${this.formatNullField(obj.client_unit)});`
                + `${this.formatNullField(obj.client_contacts[0].name)}: ${this.formatNullField(obj.client_contacts[0].phone)};`
                + `${this.formatNullField(obj.provider_name)};`
                + `${this.formatNullField(obj.provider_contacts[0].name)}: ${this.formatNullField(obj.provider_contacts[0].phone)};`
                + `${this.formatNullField(obj.address)};`
                + `${this.formatCurrency(obj.monthly_payment)};`
                + `${this.formatRenovation(obj.renovation)};`
                + `${this.formatNullField(obj.cnpj_advance)};`
                + `${this.formatNullField(obj.contract_end)};`
                + `${this.formatNullField(obj.contracted_speed)};`
                + `${this.formatNullField(obj.config_ip)};`
                + `${this.formatNullField(obj.services)};`
                + `${this.formatNullField(obj.technology)};`
                + `${this.formatNullField(obj.indice)};`
                + `${this.formatDescription(obj.description)}`;

                csv.push(row.replace(/(\r\n|\n|\r)/gm, " "));
            });

            csv = csv.join("\n");
            const csvFile = new Blob([`\uFEFF${csv}`], {
                type: 'text/csv; charset=utf-8'
            });

            const now = new Date().toLocaleString().replace(/\D/g,'_');
            const downloadLink = document.createElement("a");
            downloadLink.download = `contratos_${now}.csv`;
            downloadLink.href = window.URL.createObjectURL(csvFile);
            downloadLink.style.display = "none";
            document.body.appendChild(downloadLink);
            downloadLink.click();
        },
    },
    beforeMount() {
        this.accessLevel();
        this.getLinkContracts();
    },

}
</script>

<style scoped>

.expiring-contract {
    background-color: #f94144 !important;
    color: white;
	border-top: solid 1px white;
	border-bottom: solid 1px white;
}

.footer-table {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}

.previus {
    border-radius: 5px 0px 0px 5px !important;
}

.next {
    border-radius: 0px 5px 5px 0px !important;
}

#btn-new-contract {
    font-weight: bold;
    border-radius: 5px !important;
    margin-left: 10px;
}

.header-module .header-col-one {
    display: flex;
    justify-content: space-between;
}

.header-module .header-col-two {
	margin-top: 20px;
	margin-left: 10px;
    display: flex;
}
.quantity-viewed {
    margin-right: 10px;
}

.quantity-viewed select {
	border: solid 1px #aaa;
	border-left: none;
	border-radius: 0px 5px 5px 0px !important;
	padding: 3px 5px;
	text-align: center;
}

.quantity-viewed span {
	border: none;
	border-radius: 5px 0px 0px 5px !important;
	padding: 5px 10px;
	background-color: #3a86ff;
	color: white;
	font-weight: 600;
}

.quantity-viewed select:focus {
	box-shadow: 0 0 10px 0 #3a86ff;
    border: solid 1px #3a86ff;
    outline: none;
}

.search-contract {
    position: relative;
    width: 400px;
    border: solid 1px #aaa;
    border-radius: 20px !important;
    padding: 5px 35px 4px 15px;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.8);
}

.search-contract:focus {
    box-shadow: 0 0 10px 0 #3a86ff;
    border: solid 2px #3a86ff;
    outline: none;
}

.search-icon i {
    color: #aaa;
    position: relative;
    top: 0px;
    right: 35px;
}

.search-contract:focus + i {
    color: #3a86ff;
}

.content {
    width: 100%;
    overflow-x: auto;
}

.contract-table {
    /* table-layout: fixed;
    width: 500%; */
	margin-top: 10px;
	margin-bottom: 0px;
	font-size: 1em;
	font-family: "Sulphur Point", sans-serif;
	border-bottom: solid 2px black;
}

.contract-table td {
    padding: 5px;
    text-align: center;
    vertical-align: middle;
}

.contract-table td button {
    border-radius: 5px !important;
}

.contract-table th {
	background-color: #3a86ff;
	color: white;
    vertical-align: middle;
    text-align: center;
	padding: 5px 20px;
	font-weight: bold;
    border-right: solid 2px white;
    border-left: solid 2px white;
    cursor: pointer;
}

.contract-table tr:nth-child(even) {
	background-color: rgba(0, 0, 0, 0.05);
}

.header-table th:first-child {
	border-radius: 15px 0px 0px 0px;
}

.header-table th:last-child {
	border-radius: 0px 15px 0px 0px;
}

.contract-table > tr:hover {
	background-color: rgba(0, 0, 0, 0.1);
}

.tooltip-container {
    position: relative;
    padding-left: 40px;
    margin-bottom: 25px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.tooltip-text {
    visibility: hidden;
    width: 200px;
    background-color: white;
    color: black;
    font-size: 0.9em;
    text-align: left;
    border-radius: 5px;
    padding: 25px;
    position: absolute;
    z-index: 1;
    bottom: 90%;
    left: 0;
    box-shadow: 0 0 2em black;
}

.tooltip-container:hover .tooltip-text{
    visibility: visible;
}

.tooltip-text::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 12px;
    border-color: white transparent transparent white;
    transform: rotate(-135deg);
    bottom: -12px;
    left: 30px;
    border-radius: 6px 0px 0px 0px;
}

#contract-table > tr:nth-child(2) > th:nth-child(5) {
    display: none;
}

.content::-webkit-scrollbar-track {
	border-radius: 2px;
	background-color: #F5F5F5;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
}

.content::-webkit-scrollbar-thumb {
	border-radius: 2px;
	background-color: #555;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
}

.content::-webkit-scrollbar {
    height: 10px;
	background-color: #F5F5F5;
}

</style>
